<template>
  <v-app>
    <v-content v-if="$auth.ready()">
      <router-view></router-view>
    </v-content>
    <v-content v-else>
      <v-container fluid fill-height class="background">
        <v-layout align-center justify-center>
          <v-progress-circular indeterminate :width="5" color="white"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style>
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }

  .background {
    background: -moz-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* ff3.6+ */
    background: -webkit-gradient(linear, left bottom, right top, color-stop(0%, rgba(75, 151, 205, 1)), color-stop(100%, rgba(95, 191, 141, 1))); /* safari4+,chrome */
    background: -webkit-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* safari5.1+,chrome10+ */
    background: -o-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* opera 11.10+ */
    background: -ms-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* ie10+ */
    background: linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* w3c */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5fbf8d', endColorstr='#4b97cd', GradientType=1); /* ie6-9 */
  }
</style>

<script>
  export default {
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue